module.exports = __webpack_public_path__ + "img/pic5-0.34b64474.png";